class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

function getSearchPageHeaderBottom() {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    return headerWrapper.getBoundingClientRect().bottom;
  }

  const headerContainer = document.querySelector('.header-wrapper-container');
  if (headerContainer) {
    return headerContainer.getBoundingClientRect().bottom;
  }

  const sectionHeader = document.querySelector('.section-header');
  if (sectionHeader) {
    return sectionHeader.getBoundingClientRect().bottom;
  }

  const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
  return headerHeightVar ? parseFloat(headerHeightVar) : 98;
}

function setSearchFilterStickyTop() {
  const headerWrapper = document.querySelector('.header-wrapper');
  const headerContainer = document.querySelector('.header-wrapper-container');
  const sectionHeader = document.querySelector('.section-header');

  if (headerWrapper) {
    document.documentElement.style.setProperty(
      '--search-filter-sticky-top',
      `${headerWrapper.getBoundingClientRect().bottom}px`
    );
    return;
  }

  if (headerContainer) {
    document.documentElement.style.setProperty(
      '--search-filter-sticky-top',
      `${headerContainer.getBoundingClientRect().bottom}px`
    );
    return;
  }

  if (sectionHeader) {
    document.documentElement.style.setProperty(
      '--search-filter-sticky-top',
      `${sectionHeader.getBoundingClientRect().bottom}px`
    );
    return;
  }

  const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
  document.documentElement.style.setProperty(
    '--search-filter-sticky-top',
    headerHeightVar || '98px'
  );
}

function updateSearchFilterSticky() {
  const filters = document.querySelector('.template-search #main-collection-filters');
  const searchHeader = document.querySelector('.template-search__header');

  if (!filters) return;

  if (!searchHeader || window.innerWidth > 749) {
    filters.classList.remove('search-filters--sticky-active');
    return;
  }

  setSearchFilterStickyTop();

  const headerBottom = getSearchPageHeaderBottom();
  const searchBottom = searchHeader.getBoundingClientRect().bottom;

  if (searchBottom <= headerBottom + 1) {
    filters.classList.add('search-filters--sticky-active');
  } else {
    filters.classList.remove('search-filters--sticky-active');
  }
}

function initSearchFilterSticky() {
  updateSearchFilterSticky();
  window.addEventListener('scroll', updateSearchFilterSticky, { passive: true });
  window.addEventListener('resize', updateSearchFilterSticky);
  window.addEventListener('load', updateSearchFilterSticky);

  const sectionHeader = document.querySelector('.section-header');
  if (sectionHeader) {
    new MutationObserver(() => {
      setTimeout(updateSearchFilterSticky, 50);
    }).observe(sectionHeader, { attributes: true, childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchFilterSticky);
} else {
  initSearchFilterSticky();
}

customElements.define('main-search', MainSearch);
